import React, {useEffect, useState} from "react";
import { Controller, Control, FieldErrors } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

type AvailableDatePickerProps = {
    name: string;
    label?: string;
    control: Control<any>;
    errors: FieldErrors;
    required?: boolean;
    className?: string;
    wrapperClassName?: string;
    availableDates?: Date[];
    colorUnavailableDates?: boolean;
};

const CustomInput = React.forwardRef<HTMLInputElement, any>(
    ({ value, onClick, onChange, placeholder, className }, ref) => (
        <input
            type="text"
            readOnly
            ref={ref}
            onClick={onClick}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
            className={className}
        />
    )
);
CustomInput.displayName = "CustomInput";

export const AvailableDatePicker: React.FC<AvailableDatePickerProps> = ({
        name,
        label = null,
        control,
        errors,
        required = false, 
        wrapperClassName = "mb-3",
        className = "form-control form-control-lg",
        availableDates = [], 
        colorUnavailableDates = false
    }) => {
    const hasError = Boolean(errors[name]);
    const [availableStrings, setAvailableStrings] = useState<Set<string> | null>(null);
    useEffect(() => {
        if(availableDates && availableDates.length > 0){
            const availableStringsSet = new Set(
                availableDates?.map(d => d.toISOString().slice(0,10))
            );
            console.log(availableStringsSet)
            setAvailableStrings(availableStringsSet);
        }
    }, [availableDates]);
    return (
        <div className={wrapperClassName}>
            {label && <label htmlFor={name} className="form-label">
                {label}
                {required && <span className="text-danger">*</span>}
            </label>}
            <Controller
                control={control}
                name={name}
                rules={{
                    required: required ? "This field is required." : false
                }}
                render={({ field }) => (
                    <>
                        <DatePicker
                            id={name}
                            placeholderText="Select Date"
                            selected={field.value}
                            className={className}
                            isClearable
                            onChange={field.onChange}
                            // if no availableDates: allow all dates
                            includeDates={
                                availableDates.length > 0 && !colorUnavailableDates
                                    ? availableDates
                                    : undefined
                            }
                            dayClassName={(date) => {
                                if (!availableStrings || !colorUnavailableDates) return undefined;
                                const key = date.toISOString().slice(0, 10);
                                const isAvailable = availableStrings.has(key);
                                return !isAvailable ? "unavailable-day" : undefined;
                            }}
                            dateFormat="yyyy-MM-dd"
                            customInput={
                                <CustomInput
                                    className={`${className}${hasError ? " is-invalid" : ""}`}
                                />
                            }
                        />
                        
                    </>
                )}
            />
        </div>
    );
};
